'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M853.806 229.076c-22.21-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-432c-44.112 0-80 35.888-80 80v240l32 704 32-704v-240c0-8.672 7.328-16 16-16 0 0 431.956-0.002 432 0v224c0 17.672 14.324 32 32 32h224l32 704 32-704c0-14.332-4.372-39.35-42.194-90.924zM640 256v-153.946c22.982 17.78 50.678 41.878 81.374 72.572 30.7 30.7 54.8 58.398 72.58 81.374h-153.954z' }),
        React.createElement('path', { d: 'M384 1024h192v-320h160l-256-256-256 256h160z' })
    ));
};